import React, { useEffect, useState } from "react";
import { Button, notification } from "antd";
import fetchStats from "../utils/fetchStats";
import { load_storage } from "../utils/localstorage";

const RefeshAlert = ({ userId }) => {
  const [timer, setTimer] = useState();

  const close = (refresh) => {
    if (refresh) {
      if (timer) clearTimeout(timer);
      window.location.reload(true);
    } else {
      fetchStats("refreshCancel");
      if (timer) clearTimeout(timer);
    }
    notification.destroy("refresh-alert");
  };

  const openNotification = () => {
    const key = `refresh-alert`;
    const btn = (
      <>
        <Button danger size="small" type="primary" onClick={() => close()}>
          Cancel
        </Button>
        <Button
          style={{ marginLeft: 8 }}
          type="primary"
          size="small"
          onClick={() => close(1)}
        >
          Refresh Now
        </Button>
      </>
    );
    setTimer(
      setTimeout(() => {
        window.location.reload(true);
      }, 60000)
    );
    notification.open({
      message: "Alert",
      description: `The Window will get auto refeshed in 60 seconds as a new update is available`,
      btn,
      key,
      placement: "top",
      duration: 30,
      onClose: () => close(),
    });
  };
  const updateVersion = () => {
    const token = load_storage("access_token");
    if (token) {
      fetch(
        `${process.env.REACT_APP_API_BASE_URL}api/version/${process.env.REACT_APP_VERSION}`,
        {
          headers: {
            Authorization: token,
          },
        }
      )
        .then((data) => {
          if (!data.ok) {
            throw new Error("Version call failed");
          }

          return data.json();
        })
        .then((data) => {
          if (data) {
            openNotification();
          }
        })
        .catch((e) => {
          console.log(e.message);
        });
    }
  };

  useEffect(() => {
    updateVersion();
  }, [userId]);

  return <></>;
};

export default RefeshAlert;
